<template>
  <v-navigation-drawer
    :value="true"
    clipped
    bottom
    app
    :mini-variant="!isAdminSidebarOpen"
    width="325px"
    mobile-breakpoint="0"
    class="sidebar sidebar--account"
    :class="isMainSidebarOpen ? 'sidebar--account--translateX' : ''"
  >
    <v-list
      nav
      dense
    >
      <v-list-item class="d-flex justify-end pe-0">
        <v-btn
          id="btnAdminSidebar"
          icon
          @click="$store.dispatch('app/setSecondSidebarOpenState', !isAdminSidebarOpen)"
        >
          <v-icon>{{ toggleIcon }}</v-icon>
        </v-btn>
      </v-list-item>
      <AccountSidebarItem
        url="/v/super/home"
        icon="mdi-home-analytics"
        title="Super Admin Dashboard"
        :isAccountSidebarOpen="isAdminSidebarOpen"
      />
      <v-divider class="my-3" />
      <div
        v-for="link in accountLinks"
        :key="link.url"
        class="mb-1"
      >
        <AccountSidebarGroup
          v-if="link.subLinks"
          :cssClass="link.cssClass"
          :icon="`fas fa-${link.icon}`"
          :title="link.title"
          :isAdminSidebarOpen="isAdminSidebarOpen"
          :isExternalLink="link.isExternal"
          :subLinks="link.subLinks"
          :startSubmenuOpen="link.startSubmenuOpen"
          :storeLocation="link.storeLocation"
        />
        <AccountSidebarItem
          v-else
          :url="link.url"
          :cssClass="link.cssClass"
          :icon="link.icon"
          :title="link.title"
          :isAccountSidebarOpen="isAdminSidebarOpen"
          :isExternalLink="link.isExternal"
        />
      </div>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import userPermissionLevel from "@/mixins/userPermissionLevel.js";
import { mapGetters } from "vuex";
import AccountSidebarItem from "@/components/AccountSidebarItem.vue";
import AccountSidebarGroup from "@/components/AccountSidebarGroup.vue";

export default {
  mixins: [userPermissionLevel],
  components: {
    AccountSidebarItem,
    AccountSidebarGroup,
  },
  data() {
    return {
      // isTreasurer: false,
    };
  },
  computed: {
    ...mapGetters({
      userId: "auth/getUserId",
      token: "auth/getToken",
      isMainSidebarOpen: "app/getMainSidebarOpenState",
      isAdminSidebarOpen: "app/getSecondSidebarOpenState",
      isAccountSubmenuOpen: "app/getAccountSubmenuOpenState",
      isEventSubmenuOpen: "app/getEventSubmenuOpenState",
    }),
    toggleIcon() {
      return this.isAdminSidebarOpen
        ? "mdi-chevron-double-left"
        : "mdi-chevron-double-right";
    },
    authQuery() {
      return `user=${this.userId}&token=${this.token}`;
    },
    isTreasurer() {
      return this.$auth.isSuperAdminOrTreasurerForAccount(
        this.$route.params.id
      );
    },
    isTreasurerOrConsultant() {
      if (this.isTreasurer) {
        return true;
      }

      return this.getUserPermissionLevel() <= 21;
    },
    accountLinks() {
      let accountLinks = [
        // {
        //   title: 'Account Settings',
        //   icon: 'cog',
        //   isForTreasurersOnly: false,
        //   isForTreasurerOrConsultant: true,
        //   startSubmenuOpen: this.isAccountSubmenuOpen,
        //   storeLocation: "app/setAccountSubmenuOpenState",
        //   subLinks: [
        //     {
        //       title: 'Account Details',
        //       url: `/v/account/${this.accountId}/details`,
        //       isExternal: false,
        //       isForTreasurersOnly: false,
        //     },
        //     {
        //       title: 'Bank Information',
        //       url: `/v/account/${this.accountId}/banking`,
        //       isExternal: false,
        //       isForTreasurersOnly: true,
        //     },
        //     {
        //       title: 'Compliance',
        //       url: `/v/account/${this.accountId}/compliance`,
        //       isExternal: false,
        //       isForTreasurersOnly: false,
        //     },
        //     {
        //       title: 'Disbursements',
        //       url: `/v/account/${this.accountId}/disbursements`,
        //       isExternal: false,
        //       isForTreasurersOnly: false,
        //     },
        //     {
        //       title: 'Donation Page',
        //       url: `/v/account/${this.accountId}/donation-page`,
        //       isExternal: false,
        //       isForTreasurersOnly: false,
        //     },
        //     {
        //       title: 'Email Settings',
        //       url: `/v/account/${this.accountId}/EMailingList`,
        //       isExternal: false,
        //       isForTreasurerOrConsultant: true,
        //     },
        //     {
        //       title: 'Integrations',
        //       url: `/v/account/${this.accountId}/integrations`,
        //       isExternal: false,
        //       isForTreasurersOnly: false,
        //     },
        //   ],
        // },
        // {
        //   title: 'Bulk Import',
        //   url: `/v/account/${this.accountId}/imports/bulk`,
        //   icon: 'box',
        //   isExternal: false,
        //   isForTreasurersOnly: false,
        // },
        // {
        //   title: 'Campaigns',
        //   url: `/v/account/${this.accountId}/Campaigns`,
        //   icon: 'bullhorn',
        //   isExternal: false,
        //   isForTreasurersOnly: false,
        // },
        // {
        //   title: 'Events',
        //   url: `/v/account/${this.accountId}/Events`,
        //   icon: 'ticket-alt',
        //   isExternal: false,
        //   isForTreasurersOnly: false,
        // },
        {
          title: "Notifications",
          url: `/v/super/notifications`,
          icon: "mdi-bell",
          isExternal: false,
        },
        {
          title: "Attempts",
          url: `/v/super/attempts`,
          icon: "mdi-alert-box",
          isExternal: false,
        },
        {
          title: "Invoices",
          url: `/v/super/invoices`,
          icon: "mdi-file-document",
          isExternal: false,
        },
        {
          title: "Exports",
          url: `/v/super/exports`,
          icon: "mdi-file-export",
          isExternal: false,
        },
        {
          title: "Users",
          url: `/v/super/users`,
          icon: "mdi-account-group",
          isExternal: false,
        },

        // {
        //   title: 'Page Design',
        //   url: `/v/account/${this.accountId}/page-design`,
        //   icon: 'desktop',
        //   isExternal: false,
        //   isForTreasurersOnly: false,
        // },
        // {
        //   title: 'Recurring Contributions',
        //   url: `/v/account/${this.accountId}/recurring`,
        //   icon: 'sync-alt',
        //   isExternal: false,
        //   isForTreasurersOnly: false,
        //   isForTreasurerOrConsultant: true,
        // },
        // {
        //   title: 'User Management',
        //   url: `/v/account/${this.accountId}/users`,
        //   icon: 'users',
        //   isExternal: false,
        //   isForTreasurersOnly: false,
        // },
        {
          title: "View Old Super Admin",
          url: `/f/admin/super/dashboard.aspx?${this.authQuery}`,
          icon: "mdi-flag",
          isExternal: true,
        },
      ];

      accountLinks = accountLinks.map((account) => {
        account.cssClass = this.isCurrentUrl(
          this.$route.path,
          account.url
        )
          ? "sidebar__item--active"
          : "";
        return account;
      });

      return accountLinks;
    },
  },
  watch: {},
  methods: {
    isCurrentUrl(currentPath, linkPath) {
      return currentPath === linkPath;
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep {
  .v-list-item--link:hover {
    text-decoration: none;
  }
  .sidebar--account__icon {
    width: 1.4em;
    flex-shrink: 0;
  }
  .theme--light.v-list-item--active:before,
  .theme--light.v-list-item--active:hover:before {
    opacity: 0;
  }
  .theme--light.v-list-item--active.sidebar__item--active:before,
  .theme--light.v-list-item--active.sidebar__item--active:hover:before {
    opacity: 0.12;
    background-color: rgb(76, 178, 241);
  }
  .v-list .v-list-item--active.sidebar__item--active,
  .v-list .v-list-item--active.sidebar__item--active .v-icon {
    // color: #4cb2f1;
    color: #0093ee !important;
  }
}

@media all and (min-width: 769px) {
  .sidebar--account {
    transform: translateX(0) !important;
  }
  .sidebar--account--translateX {
    transform: translateX(325px) !important;
  }
}
</style>
